interface PageTitleProps {
  title: string
  subtitle?: string
  className?: string
  titleClassName?: string
  subtitleClassName?: string
}

export function PageTitle({
  title,
  subtitle,
  className,
  titleClassName,
  subtitleClassName,
}: PageTitleProps) {
  return (
    <div className={className}>
      <h1 className={titleClassName || 'text-2xl font-medium'}>{title}</h1>
      {subtitle && (
        <p className={subtitleClassName || 'text-muted-foreground mt-1'}>
          {subtitle}
        </p>
      )}
    </div>
  )
}
